import { useModalAction } from "@components/common/CustomModal";
import { FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useQueryClient } from "@tanstack/react-query";
import type * as React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { useCreateAdminMutation } from "@/libs/generated/hooks";

function AddAdminForm() {
  const { t } = useTranslation();
  const client = useQueryClient();
  const modalAction = useModalAction();
  const { mutate: createAdmin, isPending } = useCreateAdminMutation({
    onSuccess: (data) => {
      toast(t("network.managers.created"), {
        position: "bottom-right",
        type: "success",
      });
      client.invalidateQueries({ queryKey: ["admins", Number(data?.rank)] });
      modalAction?.closeModal();
    },
    onError: (err) => {
      const message = err instanceof Error ? err.message : String(err);
      const errorText = message.split(":")[1] || message;
      toast(errorText || t("network.errors.unknown"), {
        position: "bottom-right",
        type: "error",
      });
    },
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget) as any;
    const data = Object.fromEntries(formData.entries());

    const { confirmPassword, ...rest } = data;

    if (data.password !== data.confirmPassword) {
      alert("Les mots de passe ne correspondent pas");
      return;
    }
    rest.rank = Number(rest.rank);
    createAdmin({ CreateAdminInput: rest as any });
  };
  return (
    <Box component="form" onSubmit={handleSubmit} id="addAdmin">
      <Typography
        id="transition-modal-title"
        variant="h5"
        component="h2"
        textTransform="capitalize"
        sx={{
          color: "var(--secondary-color)",
          marginBottom: 4,
        }}
      >
        {t("common.shared.new-manager-account")}
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            autoComplete="given-name"
            name="firstName"
            required
            fullWidth
            id="firstName"
            label={t("common.form.input.first-name")}
            autoFocus
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            required
            fullWidth
            id="lastName"
            label={t("common.form.input.last-name")}
            name="lastName"
            autoComplete="family-name"
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TextField
            required
            fullWidth
            id="email"
            label={t("common.form.input.email")}
            name="email"
            autoComplete="email"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            required
            fullWidth
            name="password"
            label={t("common.form.input.password")}
            type="password"
            id="password"
            autoComplete="new-password"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            required
            fullWidth
            name="confirmPassword"
            label={t("common.form.input.confirm-password")}
            type="password"
            id="confirmPassword"
            autoComplete="new-password"
          />
        </Grid>

        <Grid size={{ xs: 12, md: 12 }}>
          <FormControl fullWidth required>
            <InputLabel id="demo-simple-select-label">Admin Rank</InputLabel>
            <Select label={t("common.form.input.manager-rank")} name="rank" id="rank">
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
            </Select>
          </FormControl>
          {/*           <TextField required fullWidth name='rank' label='Rank' type='number' id='rank' />
           */}{" "}
        </Grid>
      </Grid>
    </Box>
  );
}

export default AddAdminForm;
